export const changebuyerNameReducer = (state = "", action) => {
    switch (action.type) {
      case "CHANGE_BUYER_NAME":
        return action.payload.buyerName;
      default:
        return state;
    }
  };
  